
import { defineComponent, ref, onMounted, Ref, inject } from "vue";
import { apiService } from "@services/api.service";
import ProductTile from "@components/products/tile.vue";
import UserProfileSlider from "./slider.vue";

export default defineComponent({
  name: "CiUsersProfileProducts",
  components: {
    "ci-product-tile": ProductTile,
    "ci-user-profile-slider": UserProfileSlider,
  },
  props: {
    owner: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const products: Ref<Products.TileData[][]> = ref([]);
    const slug = inject("userSlug", "");
    const loading = ref(true);

    const loadUserProducts = async () => {
      try {
        const response = await apiService.users.getUserProducts(slug);
        products.value = response.data.products.map((n, i, arr) => [n, arr[i + 1]]).filter((n, i) => i % 2 === 0);
      } catch (err) {
        apiService.handleAPIError(err);
        products.value = [];
      } finally {
        loading.value = false;
      }
    };

    onMounted(loadUserProducts);

    return {
      products,
      loading,
    };
  },
});
